import * as React from 'react';

const MinusSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M2.6 11.5h18.8v1H2.6z"
        />
    </svg>
);

MinusSvg.displayName = 'MinusSvg';
export default MinusSvg;
